export default {
  "Please read the Terms & Conditions and Privacy Statement before checking the button.":
    "Please read the Terms & Conditions and Privacy Statement before checking the button.", // 协议没选
  "It's working too fast. Please try again in 10 seconds.":
    "It's working too fast. Please try again in 10 seconds.", // 10秒后才能二次验证
  "Invitation code": "โค้ด", // 1003
  "Invitation code error": "โค้ดผิดพลาด", // 失败提示用于else
  // 注册页开始
  Name: "ชื่อ-นามสกุล",
  Age: "อายุ",
  "Please do not register if you are under 18 years old":
    "ยืนยันว่าอายุเกิน 18 ปีขณะที่สมัครเข้าร่วมกิจกรรม",
  Gender: "เพศ",
  Male: "ชาย",
  Female: "ผู้หญิง",
  Other: "อื่นๆ",
  Email: "อีเมล",
  "Phone number of emergency contact person": "เบอร์ติดต่อฉุกเฉิน",
  "Please share your professional experience": "ประสบการณ์เข้าร่วมงานวิ่ง",
  "Previous race certificate within 3 years":
    "Race ที่เข้าร่วมภายใน 3 ปีที่ผ่านมา",
  "Your information is incorrect": "ข้อมูลผิด",
  "Your registration is successful. Please check more race information on your personal center.":
    "คุณลงทะเบียนสำเร็จ โปรดตรวจสอบรายละเอียดเพิ่มเติมที่หน้าโปรไฟล์",
  "Your registration has been successfully submitted and is currently under review. Since this is a professional race, your qualification needs to undergo evaluation. Please check the status on your personal center.":
    "ลงทะเบียนสำเร็จแล้ว กำลังตรวจสอบสถานะ โปรดตรวจสอบสอบอีกครั้งที่โปรไฟล์ของคุณ",
  // 注册页结束
  // 报名成功开始
  Pending: "กำลังตรวจสอบ",
  "Congratulations!": "ยินดีด้วย!",
  // 报名成功结束
  advertisement: {
    title: "Xiaomi Smart Band 9",
    desc: "รายละเอียดเพิ่มเติมเกี่ยวกับ Xaiomi Smart Band 9",
  },
  common: {
    "Personal page": "ศูนย์ส่วนบุคคล",
    "Sign out": "Sign out",
    "Sign in": "Sign in",
    professionalRace: "Professional Race",
    runForFun: "Fun Run",
    introduction: "ข้อตกลง และเงื่อนไขการเข้าร่วม",
    termsAndCondition: "ข้อตกลง และเงื่อนไข",
    privacyStatement: "นโยบายความเป็นส่วนตัว",
    title: "Xiaomi POP Run 2024",
    mile: "",
    mile2: "",
    btn: {
      confirm: "ยืนยัน",
    },
  },
  home: {
    btn: {
      runNow: "Run Now",
    },
  },
  register: {
    disclaimer:
      "หมายเหตุ : โปรดเช็กความพร้อมของร่างกายก่อนสมัครเข้าร่วม Xiaomi POP Run 2024 ",
    submit: "ยืนยัน",
  },
  details: {
    area: {
      p: "Professional Race Running time:",
      runTime: "Run for Fun Running time:",
    },
    card: {
      countdownToRegistrationStarts: "นับถอยหลังสำหรับการลงทะเบียน",
      countdownToRegistrationEnds: "ปิดลงทะเบียนภายใน",
      Days: "วัน",
      Hours: "ชั่วโมง",
      Minutes: "นาที",
    },
    btn: {
      register: "ลงทะเบียน",
      runNow: "Run Now",
      enrollmentIsFull: "เต็มแล้ว",
      registrationIsClosed: "ปิดลงทะเบียน",
    },
    desc: {
      invitationCodeRegistration:
        "The present period is for invitation code registration",
    },
  },
  review: {
    title: "เมื่อคอนเฟิร์มแล้วไม่สามารถเปลี่ยนแปลงข้อมูลได้",
    more: "อื่นๆ ",
    text: "ปิดการแจ้งเตือน",
    btn: {
      agree: "เห็นด้วย",
      disagree: "ไม่เห็นด้วย",
    },
  },
  end: {
    logout: "Log out",
    infoHeader: {
      title: "POP Run 2024",
      runTime: "Running Time：",
      btn: {
        runNow: "Run Now",
        pending: "กำลังตรวจสอบ",
        registered: "ลงทะเบียนแล้ว",
        rejected: "Application failed",
        waiting: "รอยืนยันอีกครั้ง",
        unfortunately: "ลงทะเบียนไม่สำเร็จ",
      },
    },
    application: "ลงทะเบียน",
    checkMore: {
      about: "ดูรายละเอียดเพิ่มเติมที่",
    },
    participationHistory: {
      header: "ประวัติ",
      noHistory: "No history",
      h2: "Xiaomi Pop Run { year }-Professional Race",
    },
    share: {
      name: "ชื่อ-นามสกุล",
      country: "ประเทศ",
      download: "ดาวน์โหลด",
      shareOn: "แชร์ไปที่:",
      content: "พร้อม #XiaomiPOPRun2024 ชวนเพื่อนมาวิ่งด้วยกัน!",
      description:
        "Invite more friends to join the race and feel passion beyond limits!",
    },
  },
  footer: {
    copyright: "Copyright©2016-{year} Xiaomi.com, All Rights Reserved",
  },
  dialog: {
    logOut: {
      content: "Please check if you want to log out",
      confirm: "ยืนยัน",
      cancle: "Cancle",
    },
    countrySelect: {
      headerTitle: "ประเทศ",
      headerContent:
        "Country-City name The following list displays the hosting cities for the Xiaomi POP Run 2024",
      rowNow: "Run Now",
      footerContent:
        "*For some countries, the registration will be redirected to an external website",
    },
  },
};
